import { useState, useEffect } from 'react';
import { Point, Profile } from '@/lib/types/core';

export const useNearby = (user: Profile | null, userLoading: boolean, nearbyPoint: Point | null, setNearbyPoint: (point: Point | null) => void, setDefault: boolean=false) => {
  const [nearbyLoading, setNearbyLoading] = useState(true);

  useEffect(() => {
    if (userLoading) {
        return;
    }
    if (!nearbyPoint) {
      if (user && user.geo_location) {
        setNearbyPoint(user.geo_location);
      } else if (setDefault) {
        setNearbyPoint({
          longitude: -98.5795,
          latitude: 39.8283,
        });
      }
    }
    setNearbyLoading(false);
  }, [user, userLoading, nearbyPoint, setNearbyPoint]);

  return { nearbyLoading };
};